



// import React from "react";
// import SliderOurTeam from "../../component/slidercomponent/SliderPannaNews";

// const PannaNews = ({ data = [] }) => {
//   const fallbackData = {
//     sectionTitle: "Panna News",
//     newsItems: [
//       {
//         _id: "fallback1",
//         title: "Fallback News",
//         imageUrl: "/assets/img/news/news31.jpg",
//         category: "News",
//         publishDate: "2025-11-12",
//       },
//     ],
//   };

//   // No API data → show fallback
//   if (!Array.isArray(data) || data.length === 0) {
//     return (
//       <section className="bg-secondary-accent section-space-bottom">
//         <div className="container">
//           <div className="topic-border color-cod-gray mb-30 width-100 mt-lg-3">
//             <div className="topic-box-lg color-cod-gray">
//               {fallbackData.sectionTitle}
//             </div>
//           </div>
//           <SliderOurTeam newsItems={fallbackData.newsItems} />
//         </div>
//       </section>
//     );
//   }

//   const section = data[0];
//   const item = section?.newsItems?.[0];

//   // Wrong or empty item → fallback
//   if (
//     !item ||
//     !Array.isArray(item.title) ||
//     item.title.length === 0
//   ) {
//     return (
//       <section className="bg-secondary-accent section-space-bottom">
//         <div className="container">
//           <div className="topic-border color-cod-gray mb-30 width-100 mt-lg-3">
//             <div className="topic-box-lg color-cod-gray">
//               {fallbackData.sectionTitle}
//             </div>
//           </div>
//           <SliderOurTeam newsItems={fallbackData.newsItems} />
//         </div>
//       </section>
//     );
//   }

//   // Convert array-based API into objects
//   const newsItems = item.title.map((t, idx) => ({
//     _id: `${item._id || "news"}-${idx}`,
//     title: item.title[idx] || "No Title",
//     imageUrl: item.imageUrl?.[idx] || "/assets/img/news/news31.jpg",
//     category: item.category?.[idx] || "News",
//     publishDate: item.publishDate?.[idx] || "2025-11-12",
//   }));

//   const mid = Math.ceil(newsItems.length / 2);
//   const firstHalf = newsItems.slice(0, mid);
//   const secondHalf = newsItems.slice(mid);

//   return (
//     <section className="bg-secondary-accent section-space-bottom">
//       <div className="container">
//         <div className="topic-border color-cod-gray mb-30 width-100 mt-lg-3">
//           <div className="topic-box-lg color-cod-gray">
//             {section.sectionTitle || "Panna News"}
//           </div>
//         </div>
//         {firstHalf.length > 0 && (
//           <div className="mb-30">
//             <SliderOurTeam newsItems={firstHalf} />
//           </div>
//         )}
//         {secondHalf.length > 0 && (
//           <SliderOurTeam newsItems={secondHalf} />
//         )}
//       </div>
//     </section>
//   );
// };

// export default PannaNews;






import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API_URL = `${process.env.REACT_APP_BASE_URL}api/v1/users`;

const PannaNews = () => {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);

    // Define default static data as an object with feature and gridItems
    const staticData = {
        feature: {
            featureCategory: "News",
            featureTitle: "रैपुरा में कैट के राष्ट्रीय अध्यक्ष का आगमन आज, जिलाध्यक्ष केसरवानी ने लोगो से समय पर पहुंचने एवं स्वागत करने हेतु की अपील",
            featureImage: "/assets/img/news/news31.jpg",
            featureDate: "2025-10-06",
            featureDescription: "रैपुरा में कैट के राष्ट्रीय अध्यक्ष का आगमन आज, जिलाध्यक्ष केसरवानी ने लोगो से समय पर पहुंचने एवं स्वागत करने हेतु की अपील",
            featureType: "state"
        },
        gridItems: [
            {
                gridItemsCategory: "News",
                gridItemsTitle: "ब्रह्माकुमारी अवधेश दीदी को भावपूर्ण श्रद्धांजलि अर्पित",
                gridItemsImage: "/assets/img/news/news32.jpg",
                gridItemsDate: "2017-01-17",
                gridItemsDescription: "ब्रह्माकुमारी अवधेश दीदी को भावपूर्ण श्रद्धांजलि अर्पित",
                gridItemsType: "state"
            },
            {
                gridItemsCategory: "News",
                gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
                gridItemsImage: "/assets/img/news/news33.jpg",
                gridItemsDate: "2017-02-10",
                gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
                gridItemsType: "state"
            },
            {
                gridItemsCategory: "News",
                gridItemsTitle: "पन्ना टाइगर रिजर्व में तेंदुए की हुई संदिग्ध मौत , शरीर पर कई जगह थे घाव",
                gridItemsImage: "/assets/img/news/news34.jpg",
                gridItemsDate: "2017-03-06",
                gridItemsDescription: "पन्ना टाइगर रिजर्व में तेंदुए की हुई संदिग्ध मौत , शरीर पर कई जगह थे घाव",
                gridItemsType: "state"
            },
            {
                gridItemsCategory: "News",
                gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
                gridItemsImage: "/assets/img/news/news35.jpg",
                gridItemsDate: "2017-05-17",
                gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
                gridItemsType: "state"
            },
            {
                gridItemsCategory: "News",
                gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
                gridItemsImage: "/assets/img/news/news36.jpg",
                gridItemsDate: "2017-08-22",
                gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार",
                gridItemsType: "state"
            },
            {
                gridItemsCategory: "News",
                gridItemsTitle: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार.",
                gridItemsImage: "/assets/img/news/news37.jpg",
                gridItemsDate: "2017-12-30",
                gridItemsDescription: "अवैध पशु परिवहन पर पन्ना पुलिस की बड़ी कार्रवाई , एक आरोपी गिरफ्तार.",
                gridItemsType: "state"
            }
        ]
    };

    const fetchState = async () => {
        setLoading(true);
        try {
            const res = await axios.get(`${API_URL}/state/all`);
            console.log("res: state: ", res, res.data)
            const apiData = res.data?.data || [];
            if (apiData.length > 0) {
                const mappedData = {
                    feature: {
                        featureCategory: apiData[0].feature.featureCategory,
                        featureTitle: apiData[0].feature.featureTitle,
                        featureImage: apiData[0].feature.featureImage,
                        featureDate: apiData[0].feature.featureDate
                            ? new Date(apiData[0].feature.featureDate).toISOString().split("T")[0]
                            : "",
                        featureDescription: apiData[0].feature.featureDescription,
                        featureType: apiData[0].feature.featureType,
                    },
                    gridItems: apiData[0].gridItems.map((item) => ({
                        gridItemsCategory: item.gridItemsCategory,
                        gridItemsTitle: item.gridItemsTitle,
                        gridItemsImage: item.gridItemsImage,
                        gridItemsDate: item.gridItemsDate
                            ? new Date(item.gridItemsDate).toISOString().split("T")[0]
                            : "",
                        gridItemsDescription: item.gridItemsDescription,
                        gridItemsType: item.gridItemsType,
                    })),
                };
                setData(mappedData);
            } else {
                setData(staticData);
            }
        } catch (err) {
            console.error("API fetch failed, using static data:", err);
            setData(staticData);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchState();
    }, []);

    if (loading) {
        return <div>Loading...</div>;
    }

    // Destructure data
    const { feature, gridItems } = data;

    return (
        <>
            <section className="bg-body section-space-less30">
                <div className="container">
                    <div className="ne-isotope">
                        <div className="row">
                            <div className="col-12">
                                <div className="topic-border color-azure-radiance mb-30">
                                    <div className="topic-box-lg color-azure-radiance">राज्य की ताज़ा खबरें</div>
                                </div>
                            </div>
                        </div>
                        <div className="featuredContainer">
                            <div className="row tenies">
                                <div className="col-xl-8 col-lg-5 col-md-6 col-sm-12">
                                    <div className="row keep-items-4-md">
                                        {gridItems.map((item, index) => (
                                            <div key={index} className="col-xl-4 col-lg-6 col-md-6 col-sm-4 col-6">
                                                <div className="mb-25 position-relative">
                                                    <Link className="img-opacity-hover" to="/news_info">
                                                        <img src={item.gridItemsImage} alt="news" className="img-fluid width-100 mb-15" />
                                                    </Link>
                                                    <div className="topic-box-top-xs">
                                                        <div className="topic-box-sm color-cod-gray mb-20">{item.gridItemsCategory}</div>
                                                    </div>
                                                    <div className="post-date-dark">
                                                        <ul>
                                                            <li>
                                                                <span>
                                                                    <i className="fa fa-calendar" style={{ color: "black", margin: "1px" }} aria-hidden="true" />
                                                                </span>{item.gridItemsDate}
                                                            </li>
                                                            <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                                                            <i className="fa fa-commenting-o" style={{ fontSize: "25px", color: "black", margin: "10px" }} />
                                                        </ul>
                                                    </div>
                                                    <h3 className="title-medium-dark size-md">
                                                        <Link to="/news_info">{item.gridItemsTitle}</Link>
                                                    </h3>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="col-xl-4 col-lg-7 col-md-6 col-sm-12">

                                    <div id="text-11" className="container-wrapper widget widget_text">
                                        <div className="widget-title the-global-title">
                                            <div className="the-subtitle"><b style={{ textAlign: "center" }}>राशिफल</b><span className="widget-title-icon fa" />
                                            </div>
                                        </div>
                                        <div className="textwidget">
                                            <div style={{ height: 300 }}>
                                                <iframe src="https://piushtrivedi.neocities.org/hindi_astrology_google_gadget_part_1_updated_html2.html" width="100%" height="100%" frameBorder={0} scrolling="no" />
                                            </div>
                                        </div>
                                        <div className="clearfix" />
                                    </div>

                                    <div className="widget-title the-global-title">
                                        <div className="the-subtitle"><b style={{ textAlign: "center" }}>मौसम</b><span className="widget-title-icon fa" />
                                        </div>
                                    </div>
                                    <div className="container-wrapper widget widget_text">
                                        <div className="textwidget"><p>
                                            <iframe src="https://api.wo-cloud.com/content/widget/?geoObjectKey=16143051&language=en&region=IN&timeFormat=HH:mm&windUnit=kmh&systemOfMeasurement=metric&temperatureUnit=celsius" scrolling="no" width={290} height={318} frameBorder={0} style={{ border: '1px solid #00537F', borderRadius: 8 }} />
                                            <br />
                                        </p>
                                        </div>
                                    </div>


                                    {/* <div className="img-overlay-70 img-scale-animate mb-30">
                                        <img src={feature.featureImage} alt="news" className="img-fluid width-100" />
                                        <div className="topic-box-top-lg">
                                            <div className="topic-box-sm color-cod-gray mb-20">{feature.featureCategory}</div>
                                        </div>
                                        <div className="mask-content-lg">
                                            <div className="post-date-light">
                                                <ul>
                                                    <li>
                                                        <span>
                                                            <i className="fa fa-calendar" style={{ color: "white", fontSize: "16px" }} aria-hidden="true" />
                                                        </span>{feature.featureDate}
                                                    </li>
                                                    <li>
                                                        <i className="fa fa-share-alt" style={{ fontSize: "25px", color: "" }} />
                                                        <i className="fa fa-thumbs-o-up" style={{ fontSize: "25px", margin: "10px" }} />
                                                        <i className="fa fa-commenting-o" style={{ fontSize: "25px", margin: "10px" }} />

                                                    </li>
                                                </ul>
                                            </div>
                                            <h2 className="title-medium-light size-lg">
                                                <Link to="/news_info">{feature.featureTitle}</Link>
                                            </h2>
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default PannaNews;
